<template>
  <a-drawer :visible="visible" :width="1000" title="查询优惠券激活码" @close="close" destroy-on-close>
    <!-- 检索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="领取状态">
              <a-select v-model="query.receiveStatus" placeholder="请选择" allow-clear>
                <a-select-option :value="0">未领取</a-select-option>
                <a-select-option :value="1">已领取</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="激活码状态">
              <a-select v-model="query.status" placeholder="请选择" allow-clear>
                <a-select-option :value="0">有效</a-select-option>
                <a-select-option :value="1">失效</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="用户名称">
              <a-input v-model="query.userName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮 -->
    <div class="table-operations">
      <a-button type="primary" @click="showGenerateModal" v-hasPermi="['c11b97b4de06f12d1c180e09b6dc0ca3:0:a']">
        <a-icon type="plus" />批量生成激活码
      </a-button>
    </div>

    <!-- 表格 -->
    <a-table
      row-key="id"
      :loading="loading"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      :scroll="{ x: 900, y: 400 }"
      @change="changeSize"
    >
      <span slot="qrCode" slot-scope="text, record">
        <div
          v-if="record.encryptCode"
          class="qr-code-container"
          v-viewer
        >
          <vue-qr
            :text="record.encryptCode"
            :margin="0"
            class="qr-code-image"
          />
        </div>
        <span v-else>-</span>
      </span>
      <span slot="receiveStatus" slot-scope="text">
        {{ text === 0 ? '未领取' : '已领取' }}
      </span>
      <span slot="status" slot-scope="text">
        {{ text === 0 ? '有效' : '失效' }}
      </span>
      <span slot="createTime" slot-scope="text">{{ parseTime(text) }}</span>
    </a-table>

    <!-- 批量生成激活码弹窗 -->
    <a-modal
      title="批量生成激活码"
      :visible="generateModalVisible"
      @ok="handleGenerate"
      @cancel="generateModalVisible = false"
      :confirmLoading="submitting"
    >
      <a-form-model
        ref="generateFormRef"
        :model="generateForm"
        :rules="generateRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="激活码数量" prop="count">
          <a-input-number
            v-model="generateForm.count"
            :min="1"
            :max="1000"
            placeholder="请输入数量(1-1000)"
            style="width: 100%"
          />
        </a-form-model-item>

        <a-form-model-item label="备注" prop="remark">
          <a-textarea
            v-model="generateForm.remark"
            placeholder="请输入备注(可选)"
            :rows="3"
            :maxLength="200"
            show-word-limit
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-drawer>
</template>

<script>
import {
  getCouponActivationList,
  getCouponActivationTenantList,
  batchGenerateActivationCodes,
} from '@/api/coupon/controller/index.js'
import vueQr from 'vue-qr'
export default {
  name: 'CouponActivationDrawer',
  components: {
    vueQr,
  },
  data() {
    return {
      visible: false,
      loading: false,
      couponId: '',
      whType: '',
      list: [],
      total: 0,
      // 批量生成相关
      generateModalVisible: false,
      generateForm: {
        count: 1,
        remark: '',
      },
      generateRules: {
        count: [
          { required: true, message: '请输入激活码数量', trigger: 'blur' },
          { type: 'number', min: 1, max: 1000, message: '数量必须在1-1000之间', trigger: 'blur' },
        ],
      },
      submitting: false,
      // v-viewer 配置
      viewerOptions: {
        movable: false,
        rotatable: false,
        scalable: true,
        zoomRatio: 0.3,
        maxZoomRatio: 5,
        minZoomRatio: 0.3,
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          reset: true,
          rotateLeft: false,
          rotateRight: false,
          flipHorizontal: false,
          flipVertical: false,
        },
      },
      query: {
        pageNum: 1,
        pageSize: 10,
        receiveStatus: undefined,
        status: undefined,
        userName: '',
        couponId: '',
      },
      columns: [
        { title: '激活码', dataIndex: 'code', width: 200, align: 'center' },
        {
          title: '二维码',
          dataIndex: 'encryptCode',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'qrCode' },
        },
        {
          title: '领取状态',
          dataIndex: 'receiveStatus',
          align: 'center',
          scopedSlots: { customRender: 'receiveStatus' },
        },
        { title: '激活码状态', dataIndex: 'status', align: 'center', scopedSlots: { customRender: 'status' } },
        { title: '用户名称', dataIndex: 'name', width: 120, align: 'center' },
        { title: '插入时间', dataIndex: 'createTime', align: 'center', scopedSlots: { customRender: 'createTime' } },
      ],
    }
  },
  computed: {
    pagination() {
      return {
        current: this.query.pageNum,
        pageSize: this.query.pageSize,
        total: this.total,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`,
      }
    },
  },
  methods: {
    open(options = {}) {
      this.query = {
        pageNum: 1,
        pageSize: 10,
        receiveStatus: undefined,
        status: undefined,
        userName: '',
        couponId: options.id || '',
      }
      this.couponId = options.id || ''
      this.whType = options.whType || ''
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
    },
    getList() {
      this.loading = true
      const apiMethod = this.whType === 30 ? getCouponActivationTenantList : getCouponActivationList
      const params = { ...this.query, couponId: this.couponId }

      apiMethod(params)
        .then((res) => {
          this.list = res.data.records
          this.total = res.data.total
        })
        .finally(() => (this.loading = false))
    },
    handleQuery() {
      this.query.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.query = {
        pageNum: 1,
        pageSize: 10,
        receiveStatus: undefined,
        status: undefined,
        userName: '',
        couponId: this.couponId || '',
      }
      this.getList()
    },
    changeSize({ current, pageSize }) {
      this.query.pageNum = current
      this.query.pageSize = pageSize
      this.getList()
    },
    // 显示批量生成弹窗
    showGenerateModal() {
      this.generateForm = {
        count: 1,
        remark: '',
      }
      this.generateModalVisible = true
      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.generateFormRef) {
          this.$refs.generateFormRef.clearValidate()
        }
      })
    },
    // 处理批量生成
    handleGenerate() {
      this.$refs.generateFormRef.validate((valid) => {
        if (!valid) return

        this.submitting = true
        const params = {
          couponId: this.couponId,
          count: this.generateForm.count,
          remark: this.generateForm.remark,
        }

        batchGenerateActivationCodes(params)
          .then((res) => {
            if (res.success) {
              this.$message.success(`成功生成 ${this.generateForm.count} 个激活码`)
              this.generateModalVisible = false
              this.getList() // 刷新列表
            } else {
              this.$message.error(res.message || '生成失败')
            }
          })
          .catch((error) => {
            console.error('生成激活码失败:', error)
            this.$message.error('生成失败，请重试')
          })
          .finally(() => {
            this.submitting = false
          })
      })
    },
  },
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
}

.qr-code-container {
  cursor: pointer;
  display: inline-block;
  transition: opacity 0.3s ease;
}

.qr-code-container:hover {
  opacity: 0.8;
}

.qr-code-image {
  display: block;
}

/* v-viewer 组件图片预览样式 */
.viewer-container .viewer-canvas img {
  max-width: 80vw !important;
  max-height: 80vh !important;
  width: auto !important;
  height: auto !important;
}
</style>
